const techniqueChecker = (technique) => {
  if (technique === 'Swedish' || technique === 'Sensual') {
    return true;
  }

  return false;
};

export default techniqueChecker;
